import ChannelCession from "assets/img/svg/ChannelCession";
import ChannelCollective from "assets/img/svg/ChannelCollective";
import ChannelNumerique from "assets/img/svg/ChannelNumerique";
import ChannelOther from "assets/img/svg/ChannelOther";
import ChannelPhysique from "assets/img/svg/ChannelPhysique";
import { ChannelKind } from "store/types";

interface IChannelCategoryIcon {
    kind: number;
    size?: string;
}

const ChannelCategoryIcon = ({ kind, size = "15px" }: IChannelCategoryIcon) => {
    switch (kind) {
        case ChannelKind.PHYSICAL:
            return <ChannelPhysique width={size} height={size} />;
        case ChannelKind.DIGITAL:
            return <ChannelNumerique width={size} height={size} />;
        case ChannelKind.RIGHTS_TRANSFER:
            return <ChannelCession width={size} height={size} />;
        case ChannelKind.COLLECTIVE_MANAGEMENT:
            return <ChannelCollective width={size} height={size} />;
        default:
            return <ChannelOther width={size} height={size} />;
    }
};

export default ChannelCategoryIcon;
